
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppMessagesDialog extends Serenity.EntityDialog<WhatsAppMessagesRow, any> {
        protected getFormKey() { return WhatsAppMessagesForm.formKey; }
        protected getIdProperty() { return WhatsAppMessagesRow.idProperty; }
        protected getLocalTextPrefix() { return WhatsAppMessagesRow.localTextPrefix; }
        protected getNameProperty() { return WhatsAppMessagesRow.nameProperty; }
        protected getService() { return WhatsAppMessagesService.baseUrl; }
        protected getDeletePermission() { return WhatsAppMessagesRow.deletePermission; }
        protected getInsertPermission() { return WhatsAppMessagesRow.insertPermission; }
        protected getUpdatePermission() { return WhatsAppMessagesRow.updatePermission; }

        protected form = new WhatsAppMessagesForm(this.idPrefix);

    }
}